import { useEffect } from "react";

const SITE = "The Farm To You";
const DEFAULT_DESC =
  "A nationwide, membership-first farm-to-door marketplace. Real American farms. Real food. Delivered with care, harvested with pride.";
const DEFAULT_IMG = "/og-image.jpg";

// Track ownership of meta tags so navigating between pages cleans them up.
const TFTY_META_KEY = "data-tfty-seo";

function upsertMeta(attrName, attrValue, content) {
  let el = document.head.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attrName, attrValue);
    el.setAttribute(TFTY_META_KEY, "1");
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    el.setAttribute(TFTY_META_KEY, "1");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, image, path = "" }) {
  const fullTitle = title ? `${title} · ${SITE}` : SITE;
  const desc = description || DEFAULT_DESC;
  const img = image || DEFAULT_IMG;

  useEffect(() => {
    document.title = fullTitle;
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const url = `${origin}${path}`;
    // og:image must be absolute for social crawlers (FB, LinkedIn, iMessage)
    const absImg = img.startsWith("http") ? img : `${origin}${img}`;
    upsertMeta("name", "description", desc);
    upsertCanonical(url);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", SITE);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:image", absImg);
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", absImg);
  }, [fullTitle, desc, img, path]);

  return null;
}
